
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.426 14.806L19.864.32h3.899l-2.44 14.486h-3.897zM35.41.632c-.773-.294-1.983-.609-3.495-.609-3.853 0-6.567 1.965-6.59 4.781-.022 2.082 1.938 3.243 3.417 3.936 1.518.71 2.028 1.163 2.02 1.797-.01.97-1.212 1.414-2.333 1.414-1.56 0-2.39-.22-3.67-.76l-.503-.23-.547 3.243c.911.404 2.595.754 4.344.773 4.099 0 6.76-1.943 6.79-4.95.014-1.648-1.024-2.902-3.274-3.936-1.363-.67-2.198-1.117-2.189-1.796 0-.602.707-1.246 2.233-1.246a7.116 7.116 0 012.919.555l.35.167.528-3.14zM45.445.319h-3.013c-.933 0-1.632.258-2.042 1.202L34.6 14.796h4.094s.67-1.785.82-2.177l4.994.007c.117.507.475 2.17.475 2.17H48.6L45.445.32zm-4.78 9.355c.322-.835 1.553-4.05 1.553-4.05-.023.039.32-.839.517-1.382l.264 1.248.902 4.183h-3.237zM14.114.319l-3.817 9.88-.407-2.008c-.71-2.314-2.924-4.822-5.4-6.077l3.49 12.669 4.126-.005L18.247.32h-4.131","fill":"#0E4595"}}),_c('path',{attrs:{"d":"M6.737.32H.449L.4.62c4.892 1.2 8.129 4.098 9.473 7.58L8.504 1.543C8.268.625 7.584.352 6.737.32","fill":"#F2AE14"}})])
          )
        }
      }
    